import { t } from '@lingui/macro';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';
import { DowntimeParkingsPeriodFilterValues } from '../../../constants/variables';
import { getStyleFilterItems } from '../../../constants/filterStylesResolver';
import { DOWNTIME_SCOOTERS_FILTER } from '../../../constants/filterStyles';
import { AGG_SCOOTERS_QUANTITY_LEGEND } from '../../../constants/legends';
import { i18n } from '@lingui/core';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React, { Fragment } from 'react';
import { ReactComponent as CircleLegend } from '../../../assets/images/circle.svg';
import { onChangeDowntimeFilter, onChangeDowntimePeriodFilter } from '../../../ac/onChangeMapFilters';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { StandardRadioGroup } from '../StandardRadioGroup';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';

const AggScootersDowntimeComponent = ({
    mapFilters,
    onChangeDowntimeFilter,
    onChangeDowntimePeriodFilter,
    aggScootersDowntimePeriodStatuses,
}) => {
    // ✅ НОВАЯ АРХИТЕКТУРА: использование стилей из filterStyles
    const items = getStyleFilterItems(DOWNTIME_SCOOTERS_FILTER.style, DOWNTIME_SCOOTERS_FILTER.styleKey);

    return (
        <div>
            {/* Period Filter Section */}
            <div className={styles.legHead}>{t`Период`}:</div>
            <StandardRadioGroup
                value={String(aggScootersDowntimePeriodStatuses)}
                onChange={onChangeDowntimePeriodFilter}
            >
                {DowntimeParkingsPeriodFilterValues.map(({ label, value }) => (
                    <FormControlLabel
                        key={value}
                        className={styles.isochroneFilterLabel}
                        control={
                            <Radio
                                checked={aggScootersDowntimePeriodStatuses === value}
                                onChange={onChangeDowntimePeriodFilter}
                                value={value}
                                className={classnames(
                                    styles.isochroneFilterInput, {
                                        [styles.checkedIsochroneFilterInput]: aggScootersDowntimePeriodStatuses === value,
                                    }
                                )}
                                size='small'
                            />
                        }
                        label={i18n._(label)}
                        labelPlacement='end'
                    />
                ))}
            </StandardRadioGroup>

            {/* Downtime Legend Section */}
            <div className={styles.legHead}>{t`Среднее время простоя девайсов на парковке, ч:`}</div>
            <div className={styles.checkboxIconGrid}>
                {items.map(({ value, color, label }) => (
                    <Fragment key={value}>
                        <CircleLegend
                            fill={color}
                            width='2vw'
                            height='2vw'
                            opacity='0.8'
                        />
                        <label htmlFor={label && label.id ? label.id : value}>
                            {typeof label === 'string' ? label : (label && i18n._(label))}
                        </label>
                        <div>
                            <label className={styles.switch}>
                                <input
                                    type='checkbox'
                                    name='poi'
                                    id={value}
                                    checked={mapFilters.downtimeStatuses.includes(value)}
                                    value={value}
                                    onChange={onChangeDowntimeFilter}
                                />
                                <span className={classnames(styles.sliderRound, styles.slider)} />
                            </label>
                        </div>
                    </Fragment>
                ))}
            </div>

            {/* Size Legend Section - using new SizeRangeHorizontalLegend */}
            <LegendRenderer config={AGG_SCOOTERS_QUANTITY_LEGEND} />
        </div>
    );
};
const mapStateToProps = ({ mapFilters }) => ({
    mapFilters,
    aggScootersDowntimePeriodStatuses: mapFilters.aggScootersDowntimePeriodStatuses,
});
const ConnectedComponent = connect(mapStateToProps, {
    onChangeDowntimeFilter,
    onChangeDowntimePeriodFilter,
})(AggScootersDowntimeComponent);

export const AggScootersDowntimeLegend = withDisplayedLayersCheck(
    ConnectedComponent,
    t`Агрегированный простой самокатов`
);
